import { LogPointsApplicationsState } from './model'
import { ActionType, LogPointsApplicationsAction } from './actions'

export const logPointsApplicationsInitialState = {
  logPointsConnectors: {},
  logPointsConnectorsLoading: true,
  logPointsConnectorsSaving: false,
  hasSavedYet: false
}

const reducer =
  (state: LogPointsApplicationsState = logPointsApplicationsInitialState, action: LogPointsApplicationsAction): LogPointsApplicationsState => {
    switch (action.type) {
      case ActionType.ResetConnectorsErrorAndSaved:
        return {...state, error: undefined, hasSavedYet: false}

      case ActionType.FetchLogPointsConnectors:
        return {...state, logPointsConnectors: {}, logPointsConnectorsLoading: true}

      case ActionType.FetchedLogPointsConnectors:
        return {...state, logPointsConnectors: action.payload.logPointsConnectors, logPointsConnectorsLoading: false}

      case ActionType.SavingLogPointsConnectors:
        return {...state, logPointsConnectorsSaving: true, hasSavedYet: false, error: undefined}

      case ActionType.SavedLogPointsConnectors:
        return {...state, logPointsConnectorsSaving: false, hasSavedYet: true, error: undefined}

      case ActionType.SavedLogPointsConnectorsError:
        return {...state, logPointsConnectorsSaving: false, hasSavedYet: false, error: action.payload}

      default:
        return {...state}
    }
}

export default reducer
